module.exports = __webpack_public_path__ + "static/media/TheFutureIsNow4.5d416a8b.png";